import { A } from '@solidjs/router';
import { Show } from 'solid-js';
import Text from './Text';
import { useUserContext } from './UserContextProvider';

interface TopNavLinksProps {
    onNavigate?: () => void;
    includeAuth?: boolean;
}

export default function TopNavLinks(props: TopNavLinksProps) {
    const { user } = useUserContext();
    const nav = () => props.onNavigate?.();

    return (
        <>
            <A activeClass="active" inactiveClass="inactive" href="/" end onClick={nav}><Text val="HOME"/></A>
            <Show when={user().loggedin}>
                <A activeClass="active" inactiveClass="inactive" href="/botengine" onClick={nav}><Text val="DASHBOARD"/></A>
                <A activeClass="active" inactiveClass="inactive" href="/goggles" onClick={nav}><Text val="GOGGLES_NAV"/></A>
                <A activeClass="active" inactiveClass="inactive" href="/vektorutils" onClick={nav}><Text val="VEKTORUTILS_NAV"/></A>
            </Show>
            <A activeClass="active" inactiveClass="inactive" href="/jobs" onClick={nav}><Text val="JOBS"/></A>
            <A activeClass="active" inactiveClass="inactive" href="/security" onClick={nav}><Text val="NAV_SECURITY"/></A>
            <Show when={props.includeAuth}>
                <Show when={!user().loggedin}>
                    <A activeClass="active" inactiveClass="inactive" href="/login" onClick={nav}><Text val="LOGIN"/></A>
                    <A activeClass="active" inactiveClass="inactive" href="/register" end onClick={nav}><Text val="REGISTER"/></A>
                </Show>
                <Show when={user().loggedin}>
                    <A activeClass="active" inactiveClass="inactive" href="/me" onClick={nav}>{user().username}</A>
                </Show>
            </Show>
        </>
    );
}
